//SET:3rd
import { combineReducers } from "redux";
import { connectRouter } from 'connected-react-router';

import CouponReducer from "./CouponReducer";

const createRouteReducer = (history) => combineReducers({
	router: connectRouter(history),
	coupon: CouponReducer,
});

export default createRouteReducer;
